import { IIconProps } from "@/components/icons/interface";

const ListUpDownIcon = ({ width, height, color }: IIconProps) => {
  const strokeColor = color || "currentColor";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 20}
      height={height ?? 20}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-list-chevrons-up-down-icon lucide-list-chevrons-up-down"
    >
      <path d="M3 5h8" />
      <path d="M3 12h8" />
      <path d="M3 19h8" />
      <path d="m15 8 3-3 3 3" />
      <path d="m15 16 3 3 3-3" />
    </svg>
  );
};

export { ListUpDownIcon };
